export default "__VITE_ASSET__D1w4f0Ws__"